module.exports = __webpack_public_path__ + "static/media/salesMap.fdfa468a.png";